import quartzApi from '../api/QuartzApi';
import { commonActions } from './commonActions';

const root = 'QUARTZ_EDITOR_';
export const SAVE = root + 'SAVE';
export const RUN_JOB = root + 'RUN_JOB';
export const SET_JOB = root + 'SET_JOB';
export const DISCARD = root + 'DISCARD';
export const LOADING = root + 'LOADING';
export const INITIALIZE = root + 'INITIALIZE';
export const SET_MESSAGE = root + 'SET_MESSAGE';
export const SET_ACTIVE_KEY = root + 'SET_ACTIVE_KEY';
export const SET_EXPANDED_JOBS = root + 'SET_EXPANDED_JOBS';
export const DISCARD_ALL_CHANGES = root + 'DISCARD_ALL_CHANGES';
export const SET_TRIGGERS_CHANGES = root + 'SET_TRIGGERS_CHANGES';
export const HANDLE_TRIGGER_CHANGE = root + 'HANDLE_TRIGGER_CHANGE';

export const quartzActions = {
    initializeQuartzEditor: () => dispatch => {
        quartzApi
            .initializeQuartzEditor()
            .then(response => {
                dispatch({
                    type: INITIALIZE,
                    data: response,
                });
            });
    },
    setExpandedJob: key => dispatch => {
        dispatch({
            type: SET_EXPANDED_JOBS,
            key
        });
    },
    setTriggerChanges: changes => dispatch => {
        dispatch({
            type: SET_TRIGGERS_CHANGES,
            changes
        });
    },
    setJob: (job, envName) => dispatch => {
        dispatch({
            type: SET_JOB,
            payload: {
                job: job,
                envName: envName
            },
        });
    },
    handleTriggerChange: (trigger, type, isEdited, triggers) => dispatch => {
        const obj = {
            type: type,
            trigger: trigger,
            isEdited: isEdited,
            triggers: triggers
        };
        dispatch({
            type: HANDLE_TRIGGER_CHANGE,
            obj
        });
    },
    discardChanges: (env, changes) => dispatch => {
        const obj = {
            env: env,
            changes: changes
        };
        dispatch({
            type: DISCARD,
            obj
        });
    },
    setActiveKey: key => dispatch => {
        dispatch({
            type: SET_ACTIVE_KEY,
            key
        });
    },
    discardAllChanges: () => dispatch => {
        dispatch({
            type: DISCARD_ALL_CHANGES,
        });
    },
    setLoading: (value) => dispatch => {
        dispatch({
            type: LOADING,
            value
        });
    },
    save: obj => dispatch => {
        quartzApi.save(obj)
            .then(response => {
                dispatch({
                    type: SAVE,
                    data: response
                });
                return response;
            });
    },
    setMessage: message => dispatch => {
        dispatch({
            type: SET_MESSAGE,
            message
        });
    },
    runJob: (jobName, tenants) => dispatch => {
        quartzApi
            .runJob(jobName, tenants)
            .then(response => {
                dispatch(
                    commonActions.setMessage(response.message)
                );
            });
    }
}